"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "McpController", {
    enumerable: true,
    get: function() {
        return McpController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _mcpservice = require("~/mcp/mcp.service");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _catchError = require("~/helpers/catchError");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let McpController = class McpController {
    async handleMcpRequest(tokenId, req, res, context) {
        if (!req.headers['xc-mcp-token']) {
            _catchError.NcError.unauthorized('MCP token missing');
        }
        const mcpToken = await _models.MCPToken.validateToken(context, req.headers['xc-mcp-token'], tokenId);
        req.user = await _models.User.getWithRoles(context, mcpToken.fk_user_id, {
            baseId: mcpToken.base_id,
            workspaceId: mcpToken.fk_workspace_id
        });
        // Check if user base_role is not no_access
        if ((0, _nocodbsdk.extractRolesObj)(req.user.base_roles)[_nocodbsdk.ProjectRoles.NO_ACCESS]) {
            _catchError.NcError.forbidden('User has no access');
        }
        return await this.mcpService.handleRequest(tokenId, context, req, res);
    }
    constructor(mcpService){
        this.mcpService = mcpService;
    }
};
_ts_decorate([
    (0, _common.All)('mcp/:mcpTokenId'),
    _ts_param(0, (0, _common.Param)('mcpTokenId')),
    _ts_param(1, (0, _common.Request)()),
    _ts_param(2, (0, _common.Response)()),
    _ts_param(3, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest,
        void 0,
        typeof _nocodbsdk.NcContext === "undefined" ? Object : _nocodbsdk.NcContext
    ]),
    _ts_metadata("design:returntype", Promise)
], McpController.prototype, "handleMcpRequest", null);
McpController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _mcpservice.McpService === "undefined" ? Object : _mcpservice.McpService
    ])
], McpController);
